var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMistralIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 11,
    viewBox: "0 0 15 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.21334 0H2.10645V2.08731H4.21334V0Z",
    fill: "#FFD800"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6421 0H10.5352V2.08731H12.6421V0Z",
    fill: "#FFD800"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32023 2.08691H2.10645V4.17423H6.32023V2.08691Z",
    fill: "#FFAF00"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6425 2.08691H8.42871V4.17423H12.6425V2.08691Z",
    fill: "#FFAF00"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6422 4.17383H2.10645V6.26103H12.6422V4.17383Z",
    fill: "#FF8205"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.21334 6.26172H2.10645V8.34903H4.21334V6.26172Z",
    fill: "#FA500F"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.42818 6.26172H6.32129V8.34903H8.42818V6.26172Z",
    fill: "#FA500F"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6421 6.26172H10.5352V8.34903H12.6421V6.26172Z",
    fill: "#FA500F"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M6.32195 8.35059H0V10.4379H6.32195V8.35059Z",
    fill: "#E10500"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7507 8.35059H8.42871V10.4379H14.7507V8.35059Z",
    fill: "#E10500"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMistralIcon);
export default __webpack_public_path__ + "static/media/mistral-icon.747074a7b4342fca99260aeb16151cb0.svg";
export { ForwardRef as ReactComponent };